import api from './index';
import { EDITORS_LIST_PER_PAGE_ITEMS } from '../../app.config.vars/stored';
const endpoints = {
    institutions: '/admin/institutions',
    editors: '/admin/editors',
};
export const getEditors = async (currentPage) => {
    const res = await api.get(endpoints.editors, {
        params: {
            page: currentPage,
            limit: EDITORS_LIST_PER_PAGE_ITEMS,
        },
    });
    return res.data;
};
export const getEditorsPerInstitution = async (id, currentPage) => {
    const res = await api.get(`${endpoints.institutions}/${id}/editors`, {
        params: {
            page: currentPage,
            limit: EDITORS_LIST_PER_PAGE_ITEMS,
        },
    });
    return res.data;
};
export const getEditor = async (id) => {
    const res = await api.get(`${endpoints.editors}/${id}`);
    return res.data;
};
export const addEditor = async (body) => {
    return await api.post(endpoints.editors, body);
};
export const addEditorPerInstitution = async (id, body) => {
    return await api.post(`${endpoints.institutions}/${id}/editors`, body);
};
export const updateEditor = async (id, body) => {
    return await api.patch(`${endpoints.editors}/${id}`, body);
};
export const deleteEditor = async (id) => {
    return await api.delete(`${endpoints.editors}/${id}`);
};
